export const Pokedex: import('../../../sim/dex-species').ModdedSpeciesDataTable = {
	/*
	// Example
	id: {
		inherit: true, // Always use this, makes the pokemon inherit its default values from the parent mod (gen7)
		baseStats: {hp: 100, atk: 100, def: 100, spa: 100, spd: 100, spe: 100}, // the base stats for the pokemon
	},
	*/
	// aegii
	scizor: {
		inherit: true,
		abilities: { 0: "Unburden" },
	},

	// Aelita
	melmetal: {
		inherit: true,
		abilities: { 0: "Fortified Metal" },
	},

	// Aethernum
	giratinaorigin: {
		inherit: true,
		abilities: { 0: "The Eminence in the Shadow" },
	},

	// Akir
	slowbro: {
		inherit: true,
		abilities: { 0: "Take it Slow" },
	},

	// Alex
	sprigatito: {
		inherit: true,
		baseStats: { hp: 90, atk: 61, def: 84, spa: 45, spd: 85, spe: 65 },
		abilities: { 0: "Pawprints" },
	},

	// Alexander489
	charizard: {
		inherit: true,
		abilities: { 0: "Confirmed Town" },
	},

	// Apple
	applin: {
		inherit: true,
		baseStats: { hp: 106, atk: 80, def: 110, spa: 120, spd: 80, spe: 44 },
		abilities: { 0: "Orchard's Gift" },
	},

	// Appletun a la Mode
	appletun: {
		inherit: true,
		abilities: { 0: "Served Cold" },
	},

	// April
	leafeon: {
		inherit: true,
		abilities: { 0: "Twin Fantasy" },
	},

	// aQrator
	totodile: {
		inherit: true,
		baseStats: { hp: 85, atk: 105, def: 100, spa: 79, spd: 83, spe: 78 },
		abilities: { 0: "Neverending fHunt" },
	},

	// A Quag To The Past
	quagsire: {
		inherit: true,
		baseStats: { hp: 130, atk: 100, def: 75, spa: 20, spd: 60, spe: 45 },
		abilities: { 0: "Quag of Ruin" },
	},
	clodsire: {
		inherit: true,
		baseStats: { hp: 130, atk: 60, def: 75, spa: 40, spd: 100, spe: 20 },
		abilities: { 0: "Clod of Ruin" },
	},

	// Archas
	lilligant: {
		inherit: true,
		abilities: { 0: "Saintly Bullet" },
	},

	// Archfaewild
	abomasnow: {
		inherit: true,
		abilities: { 0: "Snow Warning" },
	},
	abomasnowmega: {
		inherit: true,
		abilities: { 0: "Flash Fire" },
	},

	// Arcueid
	deoxysattack: {
		inherit: true,
		abilities: { 0: "Marble Phantasm" },
	},
	deoxysdefense: {
		inherit: true,
		abilities: { 0: "Marble Phantasm" },
	},

	// Arsenal
	rabsca: {
		inherit: true,
		baseStats: { hp: 100, atk: 50, def: 100, spa: 115, spd: 100, spe: 45 },
		abilities: { 0: "Absorb Phys" },
	},

	// Artemis
	genesect: {
		inherit: true,
		abilities: { 0: "Supervised Learning" },
	},

	// Arya
	trapinch: {
		inherit: true,
		types: ["Ground", "Dragon"],
		baseStats: { hp: 80, atk: 100, def: 90, spa: 120, spd: 100, spe: 130 },
		abilities: { 0: "Punk Rock" },
	},
	flygon: {
		inherit: true,
		abilities: { 0: "Tinted Lens" },
	},

	// Audiino
	audino: {
		inherit: true,
		abilities: { 0: "Mitosis" },
	},

	// ausma
	hatterene: {
		inherit: true,
		abilities: { 0: "Cascade" },
	},

	// AuzBat
	swoobat: {
		inherit: true,
		abilities: { 0: "Magic Guard" },
	},

	// avarice
	sinistchamasterpiece: {
		inherit: true,
		abilities: { 0: "Serene Grace" },
	},

	// Beowulf
	beedrill: {
		inherit: true,
		abilities: { 0: "Intrepid Sword" },
	},

	// berry
	regirock: {
		inherit: true,
		abilities: { 0: "Sturdy" },
	},

	// Bert122
	sableye: {
		inherit: true,
		abilities: { 0: "Prankster" },
	},
	sableyemega: {
		inherit: true,
		abilities: { 0: "Pestering Assault" },
	},

	// Billo
	cosmog: {
		inherit: true,
		abilities: { 0: "Wonder Guard" },
	},
	solgaleo: {
		inherit: true,
		abilities: { 0: "Magic Guard" },
	},

	// blazeofvictory
	sylveon: {
		inherit: true,
		abilities: { 0: "Prismatic Lens" },
	},

	// Blitz
	chiyu: {
		inherit: true,
		types: ["Water", "Dark"],
		abilities: { 0: "Blitz of Ruin" },
	},

	// Breadey
	dachsbun: {
		inherit: true,
		abilities: { 0: "Painful Exit" },
	},

	// Cake
	dunsparce: {
		inherit: true,
		abilities: { 0: "Scrappy" },
	},

	// calmvibes
	marill: {
		inherit: true,
		baseStats: { hp: 100, atk: 50, def: 80, spa: 60, spd: 80, spe: 50 },
		abilities: { 0: "Huge Power" },
	},

	// Cassiopeia
	mewtwo: {
		inherit: true,
		abilities: { 0: "Hacking" },
	},
	mewtwomegax: {
		inherit: true,
		abilities: { 0: "Hacking" },
	},

	// chaos
	ironjugulis: {
		inherit: true,
		abilities: { 0: "Transistor" },
	},

	// Chloe
	tsareena: {
		inherit: true,
		abilities: { 0: "Acetosa" },
	},

	// Chris
	ragingbolt: {
		inherit: true,
		abilities: { 0: "Astrothunder" },
	},

	// ciran
	rapidash: {
		inherit: true,
		abilities: { 0: "Defiant" },
	},

	// Clefable
	clefable: {
		inherit: true,
		abilities: { 0: "That's Hacked" },
	},

	// Clem
	avalugg: {
		inherit: true,
		abilities: { 0: "Melting Point" },
	},
	avalugghisui: {
		inherit: true,
		types: ["Ice"],
		baseStats: { hp: 95, atk: 46, def: 44, spa: 184, spd: 117, spe: 95 },
		abilities: { 0: "Melting Point" },
	},

	// clerica
	mimikyu: {
		inherit: true,
		abilities: { 0: "Masquerade" },
	},
	mimikyubusted: {
		inherit: true,
		abilities: { 0: "Masquerade" },
	},

	// Clouds
	corvisquire: {
		inherit: true,
		baseStats: { hp: 98, atk: 87, def: 105, spa: 53, spd: 85, spe: 67 },
		abilities: { 0: "Jet Stream" },
	},

	// Coolcodename
	victini: {
		inherit: true,
		abilities: { 0: "Firewall" },
	},

	// Corthius
	thwackey: {
		inherit: true,
		abilities: { 0: "Grassy Emperor" },
	},

	// Dawn of Artemis
	necrozma: {
		inherit: true,
		abilities: { 0: "Form Change" },
	},
	necrozmaultra: {
		inherit: true,
		abilities: { 0: "Form Change" },
	},

	// DaWoblefet
	wobbuffet: {
		inherit: true,
		abilities: { 0: "Shadow Artifice" },
	},

	// deftinwolf
	yveltal: {
		inherit: true,
		abilities: { 0: "Sharpness" },
	},

	// dhelmise
	dhelmise: {
		inherit: true,
		abilities: { 0: "Virus" },
	},

	// EasyOnTheHills
	snorlax: {
		inherit: true,
		abilities: { 0: "Immunity" },
	},

	// Elliot
	sinistea: {
		inherit: true,
		baseStats: { hp: 69, atk: 65, def: 114, spa: 134, spd: 65, spe: 70 },
		abilities: { 0: "Natural Cure" },
	},

	// Elly
	thundurus: {
		inherit: true,
		abilities: { 0: "Storm Surge" },
	},

	// Emboar02
	emboar: {
		inherit: true,
		abilities: { 0: "Hogwash" },
	},

	// Fame
	jumpluff: {
		inherit: true,
		abilities: { 0: "Social Jumpluff Warrior" },
	},

	// Felucia
	vespiquen: {
		inherit: true,
		abilities: { 0: "Mountaineer" },
	},

	// Froggeh
	toxicroak: {
		inherit: true,
		abilities: { 0: "Super Luck" },
	},

	// Frostyicelad
	qwilfishhisui: {
		inherit: true,
		abilities: { 0: "Almost Frosty" },
	},

	// Frozoid
	gible: {
		inherit: true,
		baseStats: { hp: 65, atk: 110, def: 55, spa: 50, spd: 55, spe: 108 },
		abilities: { 0: "Snowballer" },
	},

	// Ganjafin
	wiglett: {
		inherit: true,
		baseStats: { hp: 100, atk: 80, def: 100, spa: 80, spd: 100, spe: 120 },
		abilities: { 0: "Gambling Addiction" },
	},

	// Haste Inky
	falinks: {
		inherit: true,
		baseStats: { hp: 80, atk: 100, def: 100, spa: 45, spd: 70, spe: 75 },
		abilities: { 0: "Simple" },
	},

	// havi
	gastly: {
		inherit: true,
		baseStats: { hp: 60, atk: 65, def: 60, spa: 130, spd: 75, spe: 110 },
		abilities: { 0: "Mensis Cage" },
	},

	// HiZo
	zoroarkhisui: {
		inherit: true,
		abilities: { 0: "Justified" },
	},

	// HoeenHero
	ludicolo: {
		inherit: true,
		abilities: { 0: "Misspelled" },
	},

	// hsy
	ursaluna: {
		inherit: true,
		abilities: { 0: "Hustle" },
	},

	// Hydrostatics
	pichuspikyeared: {
		inherit: true,
		baseStats: { hp: 35, atk: 55, def: 40, spa: 50, spd: 50, spe: 90 },
		abilities: { 0: 'Hydrostatic Positivity' },
		types: ["Electric", "Water"],
	},

	// in the hills
	gligar: {
		inherit: true,
		abilities: { 0: "Illiterit" },
	},

	// ironwater
	jirachi: {
		inherit: true,
		abilities: { 0: "Good as Gold" },
	},

	// Irpachuza
	mrmime: {
		inherit: true,
		abilities: { 0: "Mime knows best" },
	},

	// Isaiah
	medicham: {
		inherit: true,
		abilities: { 0: "Psychic Surge" },
	},

	// J0rdy004
	vulpixalola: {
		inherit: true,
		baseStats: { hp: 73, atk: 67, def: 75, spa: 81, spd: 100, spe: 109 },
		abilities: { 0: "Fortifying Frost" },
	},

	// Kalalokki
	flamigo: {
		inherit: true,
		abilities: { 0: "Scrappy" },
	},

	// Karthik
	staraptor: {
		inherit: true,
		abilities: { 0: "Tough Claws" },
	},

	// ken
	jigglypuff: {
		inherit: true,
		baseStats: { hp: 115, atk: 65, def: 99, spa: 65, spd: 115, spe: 111 },
		abilities: { 0: "Aroma Veil" },
	},

	// kenn
	larvitar: {
		inherit: true,
		baseStats: { hp: 100, atk: 84, def: 70, spa: 65, spd: 70, spe: 51 },
		abilities: { 0: "Deserted Dunes" },
	},

	// Kennedy
	cinderace: {
		inherit: true,
		abilities: { 0: "Anfield" },
		otherFormes: ["Cinderace-Gmax"],
	},
	cinderacegmax: {
		inherit: true,
		types: ["Fire", "Ice"],
		baseStats: { hp: 84, atk: 119, def: 78, spa: 77, spd: 81, spe: 105 },
		abilities: { 0: "You'll Never Walk Alone" },
		weightkg: 103,
	},

	// keys
	rayquaza: {
		inherit: true,
		abilities: { 0: "Defeatist" },
	},
	rayquazamega: {
		inherit: true,
		abilities: { 0: "Defeatist" },
		requiredMove: "Protector of the Skies",
	},

	// kingbaruk
	wigglytuff: {
		inherit: true,
		baseStats: { hp: 140, atk: 70, def: 80, spa: 85, spd: 80, spe: 45 },
		abilities: { 0: "Peer Pressure" },
	},

	// Kiwi
	minccino: {
		inherit: true,
		baseStats: { hp: 75, atk: 70, def: 60, spa: 60, spd: 60, spe: 75 },
		abilities: { 0: "Sure Hit Sorcery" },
	},

	// Klmondo
	cloyster: {
		inherit: true,
		abilities: { 0: "Super Skilled" },
	},

	// kolohe
	pikachu: {
		inherit: true,
		baseStats: { hp: 45, atk: 80, def: 50, spa: 75, spd: 60, spe: 120 },
		abilities: { 0: "Soul Surfer" },
	},

	// Kry
	mawile: {
		inherit: true,
		abilities: { 0: "Flash Freeze" },
	},

	// Lasen
	zekrom: {
		inherit: true,
		abilities: { 0: "Idealized World" },
	},

	// Lets go shuckles
	shuckle: {
		inherit: true,
		abilities: { 0: "Persistent" },
	},

	// Loethalion
	ralts: {
		inherit: true,
		abilities: { 0: "Psychic Surge" },
	},

	// Lumari
	ponytagalar: {
		inherit: true,
		baseStats: { hp: 65, atk: 100, def: 70, spa: 80, spd: 80, spe: 105 },
		abilities: { 0: "Pyrotechnic" },
	},

	// Lunell
	vaporeon: {
		inherit: true,
		abilities: { 0: "Low Tide, High Tide" },
	},

	// Lyna
	dragonair: {
		inherit: true,
		baseStats: { hp: 82, atk: 80, def: 80, spa: 80, spd: 80, spe: 80 },
		abilities: { 0: "Magic Aura" },
	},

	// Maia
	litwick: {
		inherit: true,
		abilities: { 0: "Power Abuse" },
	},

	// Mathy
	furret: {
		inherit: true,
		baseStats: { hp: 85, atk: 76, def: 128, spa: 90, spd: 110, spe: 110 },
		abilities: { 0: "Dynamic Typing" },
	},

	// Merritty
	torchic: {
		inherit: true,
		baseStats: { hp: 65, atk: 60, def: 60, spa: 80, spd: 70, spe: 85 },
		abilities: { 0: "End Round" },
	},

	// Meteordash
	tatsugiri: {
		inherit: true,
		abilities: { 0: "TatsuGlare" },
	},

	// Mex
	dialga: {
		inherit: true,
		abilities: { 0: "Time Dilation" },
	},

	// Miojo
	spheal: {
		inherit: true,
		baseStats: { hp: 110, atk: 95, def: 90, spa: 80, spd: 90, spe: 65 },
		abilities: { 0: "The Rolling Spheal" },
	},

	// Monkey
	infernape: {
		inherit: true,
		abilities: { 0: "Harambe Hit" },
	},

	// MyPearl
	latios: {
		inherit: true,
		abilities: { 0: "Eon Call" },
	},
	latias: {
		inherit: true,
		abilities: { 0: "Eon Call" },
	},

	// Neko
	chienpao: {
		inherit: true,
		abilities: { 0: "Weatherproof" },
	},

	// Ney
	banette: {
		inherit: true,
		abilities: { 0: "Insomnia" },
	},
	banettemega: {
		inherit: true,
		abilities: { 0: "Prankster Plus" },
	},

	// Notater517
	incineroar: {
		inherit: true,
		abilities: { 0: "Vent Crosser" },
	},

	// nya
	delcatty: {
		inherit: true,
		types: ["Fairy"],
		baseStats: { hp: 70, atk: 95, def: 95, spa: 85, spd: 85, spe: 120 },
		abilities: { 0: "Adorable Grace" },
	},

	// pants
	annihilape: {
		inherit: true,
		abilities: { 0: "Drifting" },
	},

	// PartMan
	chandelure: {
		inherit: true,
		abilities: { 0: "C- Tier Shitposter" },
	},

	// Pastor Gigas
	regigigas: {
		inherit: true,
		abilities: { 0: "God's Mercy" },
	},

	// Peary
	klinklang: {
		inherit: true,
		abilities: { 0: "Levitate" },
	},

	// phoopes
	jynx: {
		inherit: true,
		baseStats: { hp: 65, atk: 50, def: 35, spa: 115, spd: 115, spe: 95 },
		abilities: { 0: "I Did It Again" },
	},

	// Pissog
	volcarona: {
		inherit: true,
		abilities: { 0: "Drought" },
	},
	frosmoth: {
		inherit: true,
		abilities: { 0: "Snow Warning" },
	},

	// pokemonvortex
	pokestarsmeargle: {
		inherit: true,
		baseStats: { hp: 100, atk: 100, def: 100, spa: 100, spd: 100, spe: 100 },
		abilities: { 0: "Prankster" },
	},

	// Princess Autumn
	altaria: {
		inherit: true,
		abilities: { 0: "Last Hymn" },
	},
	altariamega: {
		inherit: true,
		abilities: { 0: "Last Hymn" },
	},

	// ptoad
	politoed: {
		inherit: true,
		abilities: { 0: "Drizzle" },
	},

	// Pulse_kS
	hydreigon: {
		inherit: true,
		abilities: { 0: "Pulse Luck" },
	},

	// PYRO
	kingambit: {
		inherit: true,
		abilities: { 0: "Hardcore Hustle" },
	},

	// Quite Quiet
	ribombee: {
		inherit: true,
		abilities: { 0: "Fancy Scarf" },
	},

	// quziel
	chromera: {
		inherit: true,
		abilities: { 0: "High Performance Computing" },
	},

	// R8
	chansey: {
		inherit: true,
		abilities: { 0: "Anti-Pelau" },
	},

	// Rainshaft
	xerneas: {
		inherit: true,
		abilities: { 0: "Rainy's Aura" },
	},

	// Ransei
	audinomega: {
		inherit: true,
		abilities: { 0: "Healer", 1: "Ultra Mystik" },
	},

	// ReturnToMonkey
	oranguru: {
		inherit: true,
		abilities: { 0: "Monke See Monke Do" },
	},

	// Rio Vidal
	archaludon: {
		inherit: true,
		abilities: { 0: "Built Different" },
	},

	// Rissoux
	arcaninehisui: {
		inherit: true,
		abilities: { 0: "Hard Headed" },
	},

	// RSB
	growlithe: {
		inherit: true,
		baseStats: { hp: 70, atk: 86, def: 60, spa: 86, spd: 66, spe: 76 },
		abilities: { 0: "Hot Pursuit" },
	},

	// Rumia
	duskull: {
		inherit: true,
		types: ["Ghost", "Dark"],
		baseStats: { hp: 50, atk: 55, def: 90, spa: 90, spd: 55, spe: 55 },
		abilities: { 0: "Youkai of the Dusk" },
	},

	// Scotteh
	suicune: {
		inherit: true,
		abilities: { 0: "Water Absorb" },
	},

	// SexyMalasada
	typhlosion: {
		inherit: true,
		abilities: { 0: "Ancestry Ritual" },
	},
	typhlosionhisui: {
		inherit: true,
		abilities: { 0: "Ancestry Ritual" },
	},

	// sharp_claw
	sneasel: {
		inherit: true,
		baseStats: { hp: 55, atk: 105, def: 95, spa: 35, spd: 95, spe: 135 },
		abilities: { 0: "Regenerator" },
	},
	sneaselhisui: {
		inherit: true,
		baseStats: { hp: 55, atk: 135, def: 75, spa: 35, spd: 85, spe: 135 },
		abilities: { 0: "Regenerator" },
	},

	// Siegfried
	ampharos: {
		inherit: true,
		abilities: { 0: "Static" },
	},
	ampharosmega: {
		inherit: true,
		abilities: { 0: "Magical Mystery Charge" },
	},

	// Sificon
	hoppip: {
		inherit: true,
		baseStats: { hp: 75, atk: 55, def: 70, spa: 55, spd: 95, spe: 110 },
		abilities: { 0: "Perfectly Imperfect" },
	},

	// skies
	chespin: {
		inherit: true,
		baseStats: { hp: 88, atk: 107, def: 122, spa: 74, spd: 75, spe: 64 },
		abilities: { 0: "Spikes of Wrath" },
	},

	// snake
	fidgit: {
		inherit: true,
		abilities: { 0: "Persistent" },
	},

	// Soft Flex
	magnezone: {
		inherit: true,
		abilities: { 0: "Adaptive Engineering" },
	},

	// Solaros & Lunaris
	scovillain: {
		inherit: true,
		abilities: { 0: "Ride the Sun!" },
	},

	// Spiderz
	ironthorns: {
		inherit: true,
		types: ['Dark', 'Ground'],
		abilities: { 0: "Poison Heal" },
	},

	// spoo
	hemogoblin: {
		inherit: true,
		abilities: { 0: "I Can Hear The Heart Beating As One" },
	},

	// Steorra
	kitsunoh: {
		inherit: true,
		abilities: { 0: "Ghostly Hallow" },
	},

	// Struchni
	aggron: {
		inherit: true,
		abilities: { 0: "Overasked Clause" },
	},

	// Sulo
	reuniclus: {
		inherit: true,
		abilities: { 0: "Protection of the Gelatin" },
	},

	// Swiffix
	piplup: {
		inherit: true,
		baseStats: { hp: 64, atk: 66, def: 68, spa: 81, spd: 76, spe: 50 },
		abilities: { 0: "Stinky" },
	},

	// Syrinix
	ceruledge: {
		inherit: true,
		abilities: { 0: "Sword of Ruin" },
	},

	// Teclis
	gallade: {
		inherit: true,
		abilities: { 0: "Sharpness" },
	},

	// Tenshi
	sandshrew: {
		inherit: true,
		baseStats: { hp: 50, atk: 115, def: 130, spa: 50, spd: 65, spe: 98 },
		abilities: { 0: "Sand Sleuth" },
	},

	// TheJesuchristoOsAma
	arceus: {
		inherit: true,
		abilities: { 0: "The Grace of Jesus Christ" },
	},
	arceusbug: {
		inherit: true,
		abilities: { 0: "The Grace of Jesus Christ" },
	},
	arceusdark: {
		inherit: true,
		abilities: { 0: "The Grace of Jesus Christ" },
	},
	arceusdragon: {
		inherit: true,
		abilities: { 0: "The Grace of Jesus Christ" },
	},
	arceuselectric: {
		inherit: true,
		abilities: { 0: "The Grace of Jesus Christ" },
	},
	arceusfairy: {
		inherit: true,
		abilities: { 0: "The Grace of Jesus Christ" },
	},
	arceusfighting: {
		inherit: true,
		abilities: { 0: "The Grace of Jesus Christ" },
	},
	arceusfire: {
		inherit: true,
		abilities: { 0: "The Grace of Jesus Christ" },
	},
	arceusflying: {
		inherit: true,
		abilities: { 0: "The Grace of Jesus Christ" },
	},
	arceusghost: {
		inherit: true,
		abilities: { 0: "The Grace of Jesus Christ" },
	},
	arceusgrass: {
		inherit: true,
		abilities: { 0: "The Grace of Jesus Christ" },
	},
	arceusground: {
		inherit: true,
		abilities: { 0: "The Grace of Jesus Christ" },
	},
	arceusice: {
		inherit: true,
		abilities: { 0: "The Grace of Jesus Christ" },
	},
	arceuspoison: {
		inherit: true,
		abilities: { 0: "The Grace of Jesus Christ" },
	},
	arceuspsychic: {
		inherit: true,
		abilities: { 0: "The Grace of Jesus Christ" },
	},
	arceusrock: {
		inherit: true,
		abilities: { 0: "The Grace of Jesus Christ" },
	},
	arceussteel: {
		inherit: true,
		abilities: { 0: "The Grace of Jesus Christ" },
	},
	arceuswater: {
		inherit: true,
		abilities: { 0: "The Grace of Jesus Christ" },
	},

	// Tico
	floetteeternal: {
		inherit: true,
		abilities: { 0: "Eternal Generator" },
	},

	// trace
	delphox: {
		inherit: true,
		abilities: { 0: "Eyes of Eternity" },
	},

	// Tuthur
	screamtail: {
		inherit: true,
		abilities: { 0: "Poison Heal" },
	},

	// Two of Roses
	luxray: {
		inherit: true,
		abilities: { 0: "As We See" },
	},

	// UT
	talonflame: {
		inherit: true,
		abilities: { 0: "Gale Guard" },
	},

	// Valerian
	lucario: {
		inherit: true,
		abilities: { 0: "Full Bloom" },
	},

	// Venous
	mantine: {
		inherit: true,
		abilities: { 0: "Concrete Over Water" },
	},

	// Violet
	ogerpon: {
		inherit: true,
		abilities: { 0: "See No Evil, Hear No Evil, Speak No Evil" },
	},
	ogerpontealtera: {
		inherit: true,
		abilities: { 0: "See No Evil, Hear No Evil, Speak No Evil" },
	},
	ogerponcornerstone: {
		inherit: true,
		abilities: { 0: "See No Evil, Hear No Evil, Speak No Evil" },
	},
	ogerponcornerstonetera: {
		inherit: true,
		abilities: { 0: "See No Evil, Hear No Evil, Speak No Evil" },
	},
	ogerponhearthflame: {
		inherit: true,
		abilities: { 0: "See No Evil, Hear No Evil, Speak No Evil" },
	},
	ogerponhearthflametera: {
		inherit: true,
		abilities: { 0: "See No Evil, Hear No Evil, Speak No Evil" },
	},
	ogerponwellspring: {
		inherit: true,
		abilities: { 0: "See No Evil, Hear No Evil, Speak No Evil" },
	},
	ogerponwellspringtera: {
		inherit: true,
		abilities: { 0: "See No Evil, Hear No Evil, Speak No Evil" },
	},

	// Vistar
	zeraora: {
		inherit: true,
		abilities: { 0: "Prankster" },
	},

	// vmnunes
	shayminsky: {
		inherit: true,
		abilities: { 0: "Wild Growth" },
	},

	// WarriorGallade
	tropius: {
		inherit: true,
		abilities: { 0: "Primeval Harvest" },
	},

	// Waves
	wailord: {
		inherit: true,
		abilities: { 0: "Primordial Sea" },
	},

	// WigglyTree
	sudowoodo: {
		inherit: true,
		abilities: { 0: "Tree Stance" },
		baseStats: { hp: 70, atk: 100, def: 115, spa: 30, spd: 65, spe: 50 },
	},

	// xy01
	blissey: {
		inherit: true,
		abilities: { 0: "Panic" },
	},

	// yeet dab xd
	kecleon: {
		inherit: true,
		abilities: { 0: "Treasure Bag" },
	},

	// Yellow Paint
	rotomfrost: {
		inherit: true,
		abilities: { 0: "Yellow Magic" },
	},

	ninetalesalola: {
		inherit: true,
		abilities: { 0: "Party Up" },
	},

	// YveltalNL
	farigiraf: {
		inherit: true,
		abilities: { 0: "Height Advantage" },
	},

	// za
	greedent: {
		inherit: true,
		abilities: { 0: "Troll" },
	},

	// Zalm
	weedle: {
		inherit: true,
		baseStats: { hp: 100, atk: 90, def: 100, spa: 35, spd: 90, spe: 100 },
		abilities: { 0: "Water Bubble" },
	},

	// Zarel
	meloetta: {
		inherit: true,
		abilities: { 0: "Tempo Change" },
	},
	meloettapirouette: {
		inherit: true,
		abilities: { 0: "Tempo Change" },
	},

	// zee
	lilliganthisui: {
		inherit: true,
		abilities: { 0: "Chlorophyll" },
	},

	// zoro
	umbreon: {
		inherit: true,
		abilities: { 0: "Nine Lives" },
	},
};
